/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DotMenu from 'app/components/molecules/DotMenu/DotMenu';
import Loader from 'app/components/atoms/Loader/Loader';
import history from 'store/History';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import { closeSidebar } from 'store/actions/sidebar/sidebarActions';
import { mediaBreakpoints } from 'app/themes/breakpoints';
import { setActions, setSubTitle, setTitle } from 'store/actions/sidebar/sidebarActions';
import TeamAboutTab from 'app/containers/Admin/Teams/Details/Tabs/TeamAboutTab';
import TeamHistoryTab from 'app/containers/Admin/Teams/Details/Tabs/TeamHistoryTab';
import { loadTeam } from 'store/actions/admin/teamsActions';
import { shrinkSidebar, expandSidebar } from 'store/actions/sidebar/sidebarActions';
import Chat from 'app/components/organisms/Chat/Chat';
import PageNotAllowed from 'app/containers/ErrorPages/PageNotAllowed';

class TeamSidebar extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        type: PropTypes.string,
        title: PropTypes.string,
        isOpen: PropTypes.bool,
        // from redux
        isLoading: PropTypes.bool,
        team: PropTypes.object,
    };

    validTabs = new Set(['About', 'History', 'A-Live']);

    constructor(props) {
        super(props);
        this.initData();
    }

    componentDidUpdate() {
        this.initData();
    }

    @bind
    setActions(expanded) {
        this.props.setActions(this.dotMenu(expanded));
    }

    @bind
    setSubTitle(name) {
        this.props.setSubTitle(name);
    }

    initData() {
        const { id, isOpen, isLoading, team, expanded, title } = this.props;
        if (!isOpen) {
            return;
        }
        if (!this.validTabs.has(title)) {
            this.props.setTitle('About');
        }
        this.setActions(expanded);
        if (isLoading) {
            return;
        }
        const loaded = team || {};
        if (loaded.id === id) {
            this.setSubTitle(team.name);
            return;
        }
        this.props.loadTeam(id);
    }

    @bind
    onDotMenuClick(title) {
        if (['Collapse', 'Expand'].includes(title)) {
            const { expanded, expandSidebar, shrinkSidebar } = this.props;
            const action = expanded ? shrinkSidebar : expandSidebar;
            action();
        }
        if (title === 'Go to details') {
            this.goToDetails();
        }
    }

    goToDetails() {
        const { windowWidth, id, shrinkSidebar, closeSidebar } = this.props;
        history.push(`/teams/${id}`);
        if (!windowWidth < mediaBreakpoints.sm) {
            shrinkSidebar();
        } else {
            closeSidebar();
        }
    }

    @bind
    @memoize()
    dotMenu(expanded) {
        return (
            <DotMenu
                key={13}
                onItemClick={this.onDotMenuClick}
                items={[
                    { name: expanded ? 'Collapse' : 'Expand', icon: expanded ? 'arrow-collapse' : 'open-in-new' },
                    { name: 'Go to details', icon: 'login-variant' },
                ].filter(Boolean)}
            />
        );
    }

    renderContent() {
        const { title, team } = this.props;
        switch (title) {
            case 'History':
                return <TeamHistoryTab id={team.id} />;
            case 'A-Live':
                return <Chat id={team.id} type="team" />;
            default:
                return <TeamAboutTab isSidebar details={team} />;
        }
    }

    render() {
        const { isLoading, team, isOpen, id } = this.props;
        const isLoaded = team;
        if (!isLoading && team === null) {
            return <PageNotAllowed padded permissionError={true} title={`Team. (ID:${id})`} />;
        }
        return (
            isOpen && (
                <>
                    {isLoading && <Loader absolute backdrop />}
                    {isLoaded && this.renderContent()}
                </>
            )
        );
    }
}

export default connect(
    (state, ownProps) => ({
        team: state.admin.teams.details.data,
        isLoading: state.admin.teams.details.isLoading,
        isOpen: state.sidebar.isOpen,
        expanded: state.sidebar.expanded,
        windowWidth: state.global.window.width,
        actions: state.sidebar.actions,
    }),
    { shrinkSidebar, expandSidebar, loadTeam, closeSidebar, setActions, setSubTitle, setTitle }
)(TeamSidebar);
